import * as types from '@/store/mutation-types'
import {urls, api} from '@/api'

const getInitialState = () => ({

  id: 0,
  merchant_order_id: 0,

  // publication
  publication : {
    id: 0,
    title: '',
    total_amount: 0,
  },

  // payment
  payment: {
    id: 0,
    status: '',
    date: '',
    installments: 0,
  },

  // shipping
  shipping:{
    street: '',
    number: '',
    floor: '',
    department: '',
    location: '',
    province: '',
    string: '',
    city: '',
    recipient:{
      name:"",
      phone:"",
    },
    description: ''
  },

  // buyer
  buyer: {
    id: null,
    name: '',
    phones: [],
    address: [],
    email: '',
  },

  // seller
  seller: {
    id: null,
    name: '',
    phones: [],
    address: [],
    email: '',
  }
})


const state = getInitialState()

const actions = {

  getSale: ({ commit, state, rootState, getters, dispatch }, orderId) => {
    return new Promise((resolve, reject) => {
      api.get(`${urls.marketplaceSale}/${orderId}`).then(({data: response}) => {
        dispatch('setSale', response)
        resolve();
      }).catch(error => {
        reject(error);
      })
    })
  },

  setSale: ({ commit, state, rootState, getters, dispatch }, data) => {

    // General data
    commit(types.SALE_ORDER_SET_MERCHANT_ORDER_ID, data.data.id)
    commit(types.SALE_ORDER_SET_ID, data.data.external_reference) // external_reference of the MP SDK merchant_order
    commit(types.SALE_ORDER_SET_PUBLICATION_ID, data.data.item.id)
    commit(types.SALE_ORDER_SET_TITLE, data.data.item.title)
    commit(types.SALE_ORDER_SET_TOTAL_AMOUNT, data.data.total_amount)

    // Payment data
    commit(types.SALE_ORDER_SET_PAYMENT_STATUS, data.data.payment.status)
    commit(types.SALE_ORDER_SET_INSTALLMENTS, data.data.payment.installments)
    commit(types.SALE_ORDER_SET_PAYMENT_DATE, data.data.payment.date_created)
    commit(types.SALE_ORDER_SET_PAYMENT_ID, data.data.payment.id)

    // Shipping data
    if(data.data.shipping.id) {

      // Address
      // commit(types.SALE_SHIPPING_SET_CITY, data.data.shipping.city)
      commit(types.SALE_SHIPPING_SET_DESCRIPTION, data.data.shipping.description)
      commit(types.SALE_SHIPPING_SET_STRING, data.data.shipping.string)
      commit(types.SALE_SHIPPING_SET_STREET, data.data.shipping.string.split(",")[0])
      commit(types.SALE_SHIPPING_SET_NUMBER, data.data.shipping.string.split(",")[1])
      commit(types.SALE_SHIPPING_SET_FLOOR, data.data.shipping.string.split(",")[2])
      commit(types.SALE_SHIPPING_SET_DEPARTMENT, data.data.shipping.string.split(",")[3])
      // commit(types.SALE_SHIPPING_SET_LOCATION, data.data.shipping.city.split(",")[0])
      // commit(types.SALE_SHIPPING_SET_PROVINCE, data.data.shipping.city.split(",")[1])

      // Recipient
      commit(types.SALE_SHIPPING_SET_RECIPIENT_NAME, data.data.shipping.recipient_name)
      commit(types.SALE_SHIPPING_SET_RECIPIENT_PHONE, data.data.shipping.recipient_phone)
    }

    // Buyer data
    commit(types.SALE_BUYER_SET_NAME, data.data.buyer.name)
    commit(types.SALE_BUYER_SET_PHONES, data.data.buyer.phones)
    commit(types.SALE_BUYER_SET_ADDRESS, data.data.buyer.locations)
    commit(types.SALE_BUYER_SET_EMAIL, data.data.buyer.email)
    commit(types.SALE_BUYER_SET_ID, data.data.buyer.id)

    // Seller data
    commit(types.SALE_SELLER_SET_NAME, data.data.seller.name)
    commit(types.SALE_SELLER_SET_PHONES, data.data.seller.phones)
    commit(types.SALE_SELLER_SET_ADDRESS, data.data.seller.locations)
    commit(types.SALE_SELLER_SET_EMAIL, data.data.seller.email)
    commit(types.SALE_SELLER_SET_ID, data.data.seller.id)

  },

  cleanSale: ({commit}) => new Promise((resolve, reject) => {
    commit(types.SALE_RESET_STATE)
    resolve()
  }),
}

const mutations = {
  [types.SALE_RESET_STATE] (state) {
    Object.assign(state, getInitialState())
  },
  [types.SALE_ORDER_SET_ID] (state, id) {
    state.id = id
  },
  [types.SALE_ORDER_SET_MERCHANT_ORDER_ID] (state, merchantOrderId) {
    state.merchant_order_id = merchantOrderId
  },
  [types.SALE_ORDER_SET_TOTAL_AMOUNT] (state, totalAmount) {
    state.publication.total_amount = totalAmount
  },
  [types.SALE_ORDER_SET_TITLE] (state, title) {
    state.publication.title = title
  },
  [types.SALE_ORDER_SET_PUBLICATION_ID] (state, publicationId) {
    state.publication.id = publicationId
  },
  [types.SALE_ORDER_SET_PAYMENT_STATUS] (state, status) {
    state.payment.status = status
  },
  [types.SALE_ORDER_SET_INSTALLMENTS] (state, installments) {
    state.payment.installments = installments
  },
  [types.SALE_ORDER_SET_PAYMENT_DATE] (state, paymentDate) {
    state.payment.date = paymentDate
  },
  [types.SALE_ORDER_SET_PAYMENT_ID] (state, paymentId) {
    state.payment.id = paymentId
  },
  [types.SALE_SHIPPING_SET_STREET] (state, street) {
    state.shipping.street = street
  },
  [types.SALE_SHIPPING_SET_NUMBER] (state, number) {
    state.shipping.number = number
  },
  [types.SALE_SHIPPING_SET_FLOOR] (state, floor) {
    state.shipping.floor = floor
  },
  [types.SALE_SHIPPING_SET_DEPARTMENT] (state, department) {
    state.shipping.department = department
  },
  [types.SALE_SHIPPING_SET_LOCATION] (state, location) {
    state.shipping.location = location
  },
  [types.SALE_SHIPPING_SET_PROVINCE] (state, province) {
    state.shipping.province = province
  },
  [types.SALE_SHIPPING_SET_STRING] (state, string) {
    state.shipping.string = string
  },
  [types.SALE_SHIPPING_SET_CITY] (state, city) {
    state.shipping.city = city
  },
  [types.SALE_SHIPPING_SET_DESCRIPTION] (state, description) {
    state.shipping.description = description
  },
  [types.SALE_SHIPPING_SET_RECIPIENT_NAME] (state, recipient_name) {
    state.shipping.recipient.name = recipient_name
  },
  [types.SALE_SHIPPING_SET_RECIPIENT_PHONE] (state, recipient_phone) {
    state.shipping.recipient.phone = recipient_phone
  },
  [types.SALE_BUYER_SET_NAME] (state, name) {
    state.buyer.name = name
  },
  [types.SALE_BUYER_SET_PHONES] (state, phones) {
    state.buyer.phones = phones
  },
  [types.SALE_BUYER_SET_ADDRESS] (state, address) {
    state.buyer.address = address
  },
  [types.SALE_BUYER_SET_EMAIL] (state, email) {
    state.buyer.email = email
  },
  [types.SALE_BUYER_SET_ID] (state, id) {
    state.buyer.id = id
  },
  [types.SALE_SELLER_SET_NAME] (state, name) {
    state.seller.name = name
  },
  [types.SALE_SELLER_SET_PHONES] (state, phones) {
    state.seller.phones = phones
  },
  [types.SALE_SELLER_SET_ADDRESS] (state, address) {
    state.seller.address = address
  },
  [types.SALE_SELLER_SET_EMAIL] (state, email) {
    state.seller.email = email
  },
  [types.SALE_SELLER_SET_ID] (state, id) {
    state.seller.id = id
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sale.js